import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import Editor from '@app/components/editor/Editor';
import 'react-tabs/style/react-tabs.css';
import {
    messageError,
    messageToast,
    status200,
    role,
    objectLoaiNoiDung,
    styleSelectError,
    styleSelectDefault,
    acceptImage
} from '../../utils/define';
import {
    BaseGatewayAuthImage,
    OPENIDDICTAPPLICATION_API,
    ROLE_API
} from '../../utils/apiUrl.js';
import { getInfomationAccountFromToken, isValidUrl } from '../../utils/helper';
import DatePicker from 'react-datepicker';
import loginHistory from '@app/store/reducers/loginHistory';
import { NIL as NIL_UUID } from 'uuid';
import Select from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';
import { useDispatch } from 'react-redux';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import InputFile from '@app/components/input-file/InputFile';

const schema = yup.object().shape({
    isClientApp: yup.boolean().required(), // ensures the field is present (true or false)

    // 2) client fields only when isClientApp===true
    clientAppId: yup.string().when('isClientApp', {
        is: true,
        then: (s) => s.required(messageError.emptyMessage),
        otherwise: (s) => s.notRequired()
    }),
    clientAppDisplayName: yup.string().when('isClientApp', {
        is: true,
        then: (s) => s.required(messageError.emptyMessage),
        otherwise: (s) => s.notRequired()
    }),
    clientDomain: yup.string().when('isClientApp', {
        is: true,
        then: (s) => s.required(messageError.emptyMessage),
        otherwise: (s) => s.notRequired()
    }),

    // 3) API fields only when isClientApp===false
    apiAppId: yup.string().when('isClientApp', {
        is: false,
        then: (s) => s.required(messageError.emptyMessage),
        otherwise: (s) => s.notRequired()
    }),
    apiAppDisplayName: yup.string().when('isClientApp', {
        is: false,
        then: (s) => s.required(messageError.emptyMessage),
        otherwise: (s) => s.notRequired()
    }),

    scopeName: yup.string().required(messageError.emptyMessage),
    scopeDisplayName: yup.string().required(messageError.emptyMessage),
});

const OpeniddictApplicationEdit = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');

    // const inforAccount = getInfomationAccountFromToken();
    // let accountRoleManageDevice = false;

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleManageDevice =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    //     // accountRoleBooker =
    //     //     userRole.includes(role.Admin) || userRole.includes(role.Booker);
    // }

    const itemEdit = useQuery([itemId], () =>
        Get(OPENIDDICTAPPLICATION_API.GET_ITEM, itemId)
    );

    const editFunc = useMutation((value) =>
        Put(OPENIDDICTAPPLICATION_API.UPDATE_ITEM, itemId, value)
    );

    const handleEdit = async (values) => {
        const model = { ...values };

        model.id = itemId;

        model.customScope = {
            scopeName: values.scopeName,
            scopeDisplayName: values.scopeDisplayName
        };

        model.roles = JSON.stringify(
            (values.roles || []).map((x) => ({
                id: x.id,
                name: x.name
            }))
        );

        editFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    // dispatch(
                    //     apiRoleMappingPagingAction({
                    //         PageIndex: 1,
                    //         PageSize: 10000
                    //     })
                    // );
                    queryClient.setQueryData(itemId, model);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
        Get(ROLE_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 10000
        })
    );

    const lstRole =
        listRole &&
            listRole.data &&
            listRole.data.data &&
            listRole.data.data.length > 0
            ? listRole.data.data.map((x) => ({
                name: x.name,
                id: x.id
            }))
            : [];

    // const loadOptions = async (inputValue, loadedOptions, {page}) => {
    //     console.log('lstRole', lstRole);
    //     const filteredOptions = lstRole
    //         .filter((option) =>
    //             option.label.toLowerCase().includes(inputValue.toLowerCase())
    //         )
    //         .slice(0, 6);

    //     // Return all filtered options, no matter how many there are
    //     return {
    //         options: filteredOptions,
    //         hasMore: false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };
    // };

    const loadOptions = async (inputValue, loadedOptions, { page }) => {
        const filtered = lstRole
            .filter((o) =>
                o.name.toLowerCase().includes(inputValue.toLowerCase())
            )
            .slice(0, 8);
        return {
            options: filtered,
            hasMore: false,
            additional: { page: page + 1 }
        };
    };

    const isLoading = itemEdit.isLoading ? true : false;
    const isError = itemEdit.isError ? true : false;
    const error = itemEdit.isError ? itemEdit.error : null;

    return (
        <Card>
            <Card.Header as="h5">Xem hoặc sửa ứng dụng SSO</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Đang tải...</div>
                ) : isError ? (
                    <div>Có lỗi xảy ra: ${error.message}</div>
                ) : itemEdit.data == null ? (
                    <div>Danh mục không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            clientAppId:
                                itemEdit.data && itemEdit.data.clientAppId
                                    ? itemEdit.data.clientAppId
                                    : '',
                            clientAppDisplayName:
                                itemEdit.data &&
                                    itemEdit.data.clientAppDisplayName
                                    ? itemEdit.data.clientAppDisplayName
                                    : '',
                            clientDomain:
                                itemEdit.data && itemEdit.data.clientDomain
                                    ? itemEdit.data.clientDomain
                                    : '',

                            apiAppId:
                                itemEdit.data && itemEdit.data.apiAppId
                                    ? itemEdit.data.apiAppId
                                    : '',
                            apiAppSecret: '',
                            apiAppDisplayName:
                                itemEdit.data && itemEdit.data.apiAppDisplayName
                                    ? itemEdit.data.apiAppDisplayName
                                    : '',

                            scopeName:
                                itemEdit.data &&
                                    itemEdit.data.customScope &&
                                    itemEdit.data.customScope.scopeName
                                    ? itemEdit.data.customScope.scopeName
                                    : '',
                            scopeDisplayName:
                                itemEdit.data &&
                                    itemEdit.data.customScope &&
                                    itemEdit.data.customScope.scopeDisplayName
                                    ? itemEdit.data.customScope.scopeDisplayName
                                    : '',
                            isClientApp:
                                itemEdit.data && itemEdit.data.isClientApp
                                    ? itemEdit.data.isClientApp
                                    : false,

                            imagePath: itemEdit.data && itemEdit.data.imagePath
                                ? itemEdit.data.imagePath
                                : "",
                            roles:
                                itemEdit.data && itemEdit.data.roles
                                    ? JSON.parse(itemEdit.data.roles).map((x) => ({
                                        name: x.name,
                                        id: x.id
                                    }))
                                    : []
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                {values.isClientApp ? (
                                    <HorizontalFieldsRow
                                        fields={[
                                            {
                                                label: 'Mã ứng dụng Client',
                                                name: 'clientAppId',
                                                value: values.clientAppId,
                                                onChange: handleChange,
                                                isInvalid: errors.clientAppId,
                                                error: errors.clientAppId
                                            },
                                            {
                                                label: 'Tên ứng dụng Client',
                                                name: 'clientAppDisplayName',
                                                value: values.clientAppDisplayName,
                                                onChange: handleChange,
                                                isInvalid:
                                                    errors.clientAppDisplayName,
                                                error: errors.clientAppDisplayName
                                            },
                                            {
                                                label: 'Client Domain',
                                                name: 'clientDomain',
                                                value: values.clientDomain,
                                                onChange: handleChange,
                                                isInvalid: errors.clientDomain,
                                                error: errors.clientDomain
                                            }
                                        ]}
                                    />
                                ) : (
                                    <HorizontalFieldsRow
                                        fields={[
                                            {
                                                label: 'Mã ứng dụng API',
                                                name: 'apiAppId',
                                                value: values.apiAppId,
                                                onChange: handleChange,
                                                isInvalid: errors.apiAppId,
                                                error: errors.apiAppId
                                            },
                                            {
                                                label: 'Tên ứng dụng API',
                                                name: 'apiAppDisplayName',
                                                value: values.apiAppDisplayName,
                                                onChange: handleChange,
                                                isInvalid:
                                                    errors.apiAppDisplayName,
                                                error: errors.apiAppDisplayName
                                            },
                                            {
                                                label: 'Mật khẩu ứng dụng API',
                                                name: 'apiAppSecret',
                                                value: values.apiAppSecret,
                                                onChange: handleChange,
                                                isInvalid: errors.apiAppSecret,
                                                error: errors.apiAppSecret
                                            }
                                        ]}
                                    />
                                )}
                                <HorizontalFieldsRow
                                    fields={[
                                        {
                                            label: 'Tên Scope',
                                            name: 'scopeName',
                                            value: values.scopeName,
                                            onChange: handleChange,
                                            isInvalid: errors.scopeName,
                                            error: errors.scopeName
                                        },
                                        {
                                            label: 'Tên hiển thị Scope',
                                            name: 'scopeDisplayName',
                                            value: values.scopeDisplayName,
                                            onChange: handleChange,
                                            isInvalid: errors.scopeDisplayName,
                                            error: errors.scopeDisplayName
                                        },
                                        {}
                                    ]}
                                />
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Ảnh đại diện
                                    </Form.Label>
                                    <Col sm="10">
                                        <InputFile
                                            enableReinitialize={true}
                                            values={
                                                values.imagePath
                                                    ? [
                                                        isValidUrl(
                                                            values.imagePath
                                                        )
                                                            ? values.imagePath
                                                            : BaseGatewayAuthImage +
                                                            values.imagePath
                                                    ]
                                                    : []
                                            }
                                            name="imagePath"
                                            accept={acceptImage}
                                            onChange={(files) => {
                                                if (files.length > 0) {
                                                    setFieldValue(
                                                        'imagePath',
                                                        files[0].filePath,
                                                        true
                                                    );
                                                    setFieldValue(
                                                        'imageThumbnail',
                                                        files[0].thumbPath,
                                                        true
                                                    );
                                                } else {
                                                    setFieldValue(
                                                        'imagePath',
                                                        '',
                                                        true
                                                    );
                                                    setFieldValue(
                                                        'imageThumbnail',
                                                        '',
                                                        true
                                                    );
                                                }
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                                {values.isClientApp ? (
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Quyền được cho phép truy cập app của người dùng bình thường
                                    </Form.Label>
                                    <Col sm="10">
                                        <AsyncPaginate
                                            isMulti
                                            name="roles"
                                            placeholder="Chọn quyền được cho phép truy cập app của người dùng bình thường"
                                            value={values.roles}
                                            getOptionLabel={(opt) => opt.name}
                                            getOptionValue={(opt) => opt.id}
                                            loadOptions={loadOptions}
                                            styles={
                                                errors.roles
                                                    ? styleSelectError
                                                    : styleSelectDefault
                                            }
                                            onChange={(options) => {
                                                setFieldValue(
                                                    'roles',
                                                    options
                                                );
                                            }}
                                            additional={{
                                                page: 1
                                            }}
                                        />
                                        <div
                                            className="invalid-feedback"
                                            style={{ display: 'block' }}
                                        >
                                            {errors.roles}
                                        </div>
                                    </Col>
                                </Form.Group>
                                ) : <></>}
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default OpeniddictApplicationEdit;
